import has from 'lodash/has';
import {
  SET_ERROR,
  CLEAR_ERROR,
  LOGOUT_COMPLETE,
  SET_LOCAL_ERROR,
  CLEAR_LOCAL_ERROR,
} from '../../constants/actionTypes';

import { errorMessages } from '../../constants/errorMessages';

const initialState = {
  status: false,
  error: null,
};

export const errorsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ERROR:
      return setRequestError(state, action);
    case SET_LOCAL_ERROR:
      return setLocalError(state, action);
    case CLEAR_ERROR:
      return clearRequestError(state, action);
    case CLEAR_LOCAL_ERROR:
      return clearLocalError(state, action);

    case LOGOUT_COMPLETE:
      return initialState;

    default:
      return state;
  }
};

export default errorsReducer;

function buildErrorStr(errorPayload) {
  let { type, msg } = errorPayload;

  let errorMessage = has(errorMessages, type)
    ? `we could not ${errorMessages[type]}`
    : `there was an error`;

  return msg || `Sorry, ${errorMessage}! Please try again.`;
}

function setRequestError(state, action) {
  let { payload } = action;
  let message = has(payload, 'message') ? payload.message : buildErrorStr(payload);

  return {
    ...state,
    status: true,
    error: {
      ...payload,
      message,
      severity: 'error',
    },
  };
}

function setLocalError(state, action) {
  let { payload } = action;
  let message = has(payload, 'message') ? payload.message : buildErrorStr(payload);

  return {
    ...state,
    status: true,
    localError: {
      ...payload,
      message,
      severity: 'error',
    },
  };
}

function clearRequestError(state, action) {
  return {
    ...state,
    status: false,
    error: null,
  };
}

function clearLocalError(state, action) {
  return {
    ...state,
    localError: null,
  };
}
